export const customerQueryKeys = {
  all: ['customer'] as const,
  profile: () => ['customer', 'profile'] as const,
  profileCheck: (userId: string | null | undefined) =>
    ['customer', 'profile-check', userId ?? null] as const,
  addresses: () => ['customer', 'addresses'] as const,
  cartAll: ['customer', 'cart'] as const,
  cart: (storeId: string | null | undefined, userId: string | null | undefined) =>
    ['customer', 'cart', storeId ?? null, userId ?? null] as const,
  ordersAll: ['customer', 'orders'] as const,
  orders: (userId: string | null | undefined, status: string | null | undefined) =>
    ['customer', 'orders', userId ?? null, status ?? 'all'] as const,
  ordersCountAll: ['customer', 'orders-count'] as const,
  ordersCount: (userId: string | null | undefined) =>
    ['customer', 'orders-count', userId ?? null] as const,
  orderAll: ['customer', 'order'] as const,
  order: (userId: string | null | undefined, orderId: string | null | undefined) =>
    ['customer', 'order', userId ?? null, orderId ?? null] as const,
  reviewsAll: ['customer', 'reviews'] as const,
  reviewableOrderItems: (userId: string | null | undefined, orderId: string | null | undefined) =>
    ['customer', 'reviews', 'reviewable', userId ?? null, orderId ?? 'all'] as const,
  customerProductReview: (
    userId: string | null | undefined,
    storeSlug: string,
    productId: string,
  ) => ['customer', 'reviews', 'customer-product', userId ?? null, storeSlug, productId] as const,
};
